import { DropdownItem } from "@mcleod/components";
import { AutogenLayoutExciseTaxHistoryReport } from "./autogen/AutogenLayoutExciseTaxHistoryReport";

export class ExciseTaxHistoryReport extends AutogenLayoutExciseTaxHistoryReport {
    private originalItems: DropdownItem[] | null = null;

    override onLoad(): void {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }

    pageBreaAfterProvinceChange(){
        const pageBreakAfterProvince: boolean = this.checkboxPageBreakAfterProvince.checked;
        if(pageBreakAfterProvince){
            this.checkboxPageBreakAfterCustomer.checked = false;
            this.textboxGroupBy.selectedItem = (this.textboxGroupBy.items as DropdownItem[]).find(item => item.value.startsWith("Province"));
        }
    }

    pageBreakAfterCustomerChanged(){
        const pageBreakAfterCustomer: boolean = this.checkboxPageBreakAfterCustomer.checked;
        if(pageBreakAfterCustomer) {
            this.checkboxPageBreakAfterProvince.checked = false;
            this.textboxGroupBy.selectedItem = (this.textboxGroupBy.items as DropdownItem[]).find(item => item.value.startsWith("Customer"));
        }
    }

    groupByChanged(){
        if(this.textboxGroupBy?.selectedItem?.displayValue == "None"){
            this.checkboxPageBreakAfterCustomer.checked = false;
            this.checkboxPageBreakAfterProvince.checked = false;
        }
    }

    sortByChanged(){
        if (!this.switchReportType?.checked) {
            if (!this.originalItems) {
                this.originalItems = [...(this.textboxGroupBy.items as DropdownItem[])];
            }
            if(this.textboxGroupBy?.selectedItem?.value.startsWith("None")){
                this.textboxGroupBy.selectedItem = (this.textboxGroupBy.items as DropdownItem[]).find(item =>
                    item.value.startsWith("Province")
                );
            }
            this.textboxGroupBy.items = (this.textboxGroupBy.items as DropdownItem[]).filter(
                item => !item.value.startsWith("None")
            );
        } else {
            if (this.originalItems) {
                this.textboxGroupBy.items = [...this.originalItems];
            }
        }
    }
}
